const IconBaseProps = {width: 24, height: 24}

export default IconBaseProps;
